import { useAcceptCookies } from '@lib/hooks/useAcceptCookies'
import { createContext } from 'react'

interface CookieContextType {
  acceptedCookies: boolean
  onAcceptCookies: () => void
}

export const CookieContext = createContext<CookieContextType>({
  acceptedCookies: false,
  onAcceptCookies: () => undefined,
})

const CookieProvider: React.FC = ({ children }) => {
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies()

  return (
    <CookieContext.Provider value={{ acceptedCookies, onAcceptCookies }}>
      {children}
    </CookieContext.Provider>
  )
}

export default CookieProvider
